import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 1,
			// Admin reads are cheap on the eyes and rate-limited on the server
			// (30 req/min per operator): don't refetch just because the window
			// regained focus.
			refetchOnWindowFocus: false,
		},
	},
});
